import React, { Component } from 'react';
import {Link} from 'react-router-dom'
class Footer extends Component {
    render() {
        return (
            <footer id="footer" className="clearfix">
                <div id="footer-widgets" className="container">
                    <div className="themesflat-row gutter-30">
                        <div className="col span_1_of_3">
                            <div className="widget widget_text">
                                <div className="textwidget">
                                    <p>
                                        <img src="assets/img/kliz-logo.jpeg" alt="K.Lizz Classic Hardware Logo" width={170} height={80} style={{objectFit: 'contain'}} />
                                    </p>
                                    <p className="margin-bottom-15">Your trusted partner for quality building materials in Nairobi. We flow with qualities and are ready to serve you.</p>
                                    <ul>
                                        <li>
                                            <div className="inner">
                                                <span className="fa fa-map-marker" />
                                                <span className="text">Located in Nairobi, <span className="sl">Kenya</span></span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner">
                                                <span className="fa fa-phone" />
                                                <span className="text"> 0706494665 | 0717304599 | 0748221975</span>
                                            </div>
                                        </li>
                                        <li className="margin-top-7">
                                            <div className="inner">
                                                <span className=" font-size-14 fa fa-envelope" />
                                                <span className="text">info@klizzclassichardware.co.ke</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>{/* /.widget_text */}
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                        </div>{/* /.col */}
                        <div className="col span_1_of_3">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={0} />
                            <div className="widget widget_lastest">
                                <h2 className="widget-title"><span>QUICK LINKS</span></h2>
                                <ul className="footer-links">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about-us">About Us</Link></li>
                                    <li><Link to="/products">Our Products</Link></li>
                                    <li><Link to="/services">Services</Link></li>
                                    <li><Link to="/gallery">Gallery</Link></li>
                                    <li><Link to="/contact-01">Contact Us</Link></li>
                                </ul>
                            </div>{/* /.widget_lastest */}
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={35} data-smobile={35} />
                            <div className="widget widget_socials">
                                <h2 className="widget-title margin-bottom-20"><span>FOLLOW US</span></h2>
                                <div className="socials-list color-white">
                                    <Link to="#" aria-label="Facebook"><i className="fa fa-facebook"></i></Link>
                                    {/* <Link to="#" aria-label="Twitter"><i className="fa fa-twitter"></i></Link> */}
                                    {/* <Link to="#" aria-label="Instagram"><i className="fa fa-instagram"></i></Link> */}
                                    <Link to="#" aria-label="WhatsApp"><i className="fa fa-whatsapp"></i></Link>
                                </div>
                            </div>
                        </div>{/* /.col */}
                        <div className="col span_1_of_3">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={35} data-smobile={35} />
                            <div className="widget widget_tags">
                                <h2 className="widget-title margin-bottom-30"><span>OUR PRODUCTS</span></h2>
                                <div className="tags-list">
                                    <Link to="/products">Plywood</Link>
                                    <Link to="/products">MDF Boards</Link>
                                    <Link to="/products">Blockboards</Link>
                                    <Link to="/products">Chip Boards</Link>
                                    <Link to="/products">Doors</Link>
                                    <Link to="/products">Screws</Link>
                                    <Link to="/products">Paints</Link>
                                    <Link to="/products">Hardware</Link>
                                    <Link to="/products">Tools</Link>
                                    <Link to="/products">Cement</Link>
                                </div>
                            </div>
                        </div>{/* /.col */}
                        <div className="col span_1_of_3">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={35} data-smobile={35} />
                            <div className="widget widget_instagram">
                                <h2 className="widget-title margin-bottom-30"><span>BUSINESS HOURS</span></h2>
                                <div className="business-hours">
                                    <ul style={{listStyle: 'none', padding: 0}}>
                                        <li style={{marginBottom: '10px', color: '#fff'}}>
                                            <strong>Monday - Friday:</strong><br />
                                            7:00 AM - 6:30 PM
                                        </li>
                                        <li style={{marginBottom: '10px', color: '#fff'}}>
                                            <strong>Saturday:</strong><br />
                                            7:00 AM - 6:30 PM
                                        </li>
                                        <li style={{marginBottom: '10px', color: '#fff'}}>
                                            <strong>Sunday:</strong><br />
                                            Closed
                                        </li>
                                    </ul>
                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={20} data-mobile={20} data-smobile={20} />
                                <h2 className="widget-title margin-bottom-20"><span>OUR LOCATION</span></h2>
                                <p style={{color: '#fff'}}>Visit our store in Nairobi for quality building materials and expert advice.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;